module.exports = __webpack_public_path__ + "2bb44672b4f68fd6fa2ce23e586d04d6.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/sehnsuchtslieder.jpg
// module id = 639
// module chunks = 0